import { UserGroupView, UserGroupOverviewResource } from "api/generated/model";
import { AssignmentRowUserGroup } from "components/controlAssignment/types";

function mapAssignmentRowUserGroupToUserGroupOverviewResource(
    userGroup: AssignmentRowUserGroup
): UserGroupOverviewResource {
    const userIds: number[] = userGroup.userGroupUsers.map((ugu) => ugu.id);
    return {
        userGroup: {
            id: userGroup.id,
            name: userGroup.name,
            description: userGroup.description,
        },
        userCount: userGroup.userGroupUsers.length,
        distinctUserCount: new Set(userIds).size,
    };
}

function mapUserGroupViewToUserGroupOverviewResource(
    userGroup: UserGroupView
): UserGroupOverviewResource {
    const userIds: number[] = userGroup.userGroupUsers.map((ugu) => ugu.userId);
    return {
        userGroup: {
            id: userGroup.id,
            name: userGroup.name,
            description: userGroup.description,
        },
        userCount: userGroup.userGroupUsers.length,
        distinctUserCount: new Set(userIds).size,
    };
}

export {
    mapUserGroupViewToUserGroupOverviewResource,
    mapAssignmentRowUserGroupToUserGroupOverviewResource,
};
